import {LabelRangeSliderProps} from "../../types";
import {useCallback, useEffect, useMemo, useState} from "react";

const useLabelRangeSlider = (props: LabelRangeSliderProps) => {
    const {mark, keyName, handleFilterType, filter,removeFilterKey,setChangeMinMaxValue,rangeValue} = props;
    const marks: { [key: number]: string } = useMemo(() => {
            return mark.reduce((acc, val,index) => {
                // Merge each object into the accumulator
                return {...acc, [(100 / mark.length) * index]: val};
            }, {});
    }, [mark]);
    const [value, setValue] = useState<[number, number]>([+Object.keys(marks)[rangeValue ? +rangeValue?.[0] : 0],+Object.keys(marks)[rangeValue ? +rangeValue?.[1] : Object.keys(marks).length - 1]]);
    const [isFocus,setIsFocus] = useState<boolean>(false);
    const [defaultMinMax,setDefaultMinMax] = useState<[number,number]>([+Object.keys(marks)[rangeValue ? +rangeValue?.[0] : 0],+Object.keys(marks)[rangeValue ? +rangeValue?.[1] : Object.keys(marks).length - 1]])

    const handleChangeFilterValue = useCallback((val: number | number[]): void=>{
        if (Array.isArray(val)) {
            const fromVal = Object.keys(marks)
                .sort((a, b) => (b > a ? -1 : 1))
                .indexOf(val[0].toString());
            const toVal = Object.keys(marks)
                .sort((a, b) => (b > a ? -1 : 1))
                .indexOf(val[1].toString());
            handleFilterType(`${fromVal + 1}-${toVal + 1}`, keyName);
        }
        if(Array.isArray(val) && (defaultMinMax[0] === val[0])&&(defaultMinMax[1] === val[1])){
            removeFilterKey(keyName)
        }
        setChangeMinMaxValue(false);
    },[marks,handleFilterType,value,removeFilterKey,keyName,setChangeMinMaxValue])

    const handleChange = useCallback((val: number | number[]): void => {
        if (Array.isArray(val)) {
            setValue(val as [number, number]);

            if(!isFocus){
                handleChangeFilterValue(val);
            }
        }
    }, [setValue,handleChangeFilterValue,isFocus]);

    const handleLabelChangeComplete = useCallback((val: number | number[]) => {
        handleChangeFilterValue(val)
    }, [handleChangeFilterValue]);

    // reset filter value when click reset button
    useEffect(() => {
        if (filter.isReset) {
            setValue([+Object.keys(marks)[rangeValue ? +rangeValue?.[0] : 0],+Object.keys(marks)[rangeValue ? +rangeValue?.[1] : Object.keys(marks).length - 1]]);
            setDefaultMinMax([+Object.keys(marks)[rangeValue ? +rangeValue?.[0] : 0],+Object.keys(marks)[rangeValue ? +rangeValue?.[1] : Object.keys(marks).length - 1]])
        }
    }, [filter.isReset])

    return {
        marks,
        handleLabelChangeComplete,
        value,
        handleChange,
        setIsFocus
    };
};
export default useLabelRangeSlider;
